
<list-view-filter-base
  :filter-element="filterElement"
  :key="filterElement.id"
></list-view-filter-base>
